import styled from "styled-components";
import { colors, device } from "../../../theme";
import Row from "../../atoms/Row";

export const SkillsContainer = styled(Row)`
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;

  @media ${device.tablet} {
    gap: 5%;
  }
`;

export const SkillItem = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  "& img": {
    height: 64,
    width: 64,
  },
});

export const SkillName = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${colors.white};
  margin-bottom: 10px;
  margin-top: 10px;
`;
